import React from 'react';

export function useEditorLeftPanelTabs({
    tabs,
    leftPanelTab,
    setLeftPanelTab,
    setAiView,
    aiTabValue = 'aiAssistant',
}) {
    const tabValues = React.useMemo(() => tabs.map((tab) => tab.value), [tabs]);

    React.useEffect(() => {
        if (tabValues.length === 0) {
            return;
        }
        if (!tabValues.includes(leftPanelTab)) {
            setLeftPanelTab(tabValues[0]);
        }
    }, [leftPanelTab, setLeftPanelTab, tabValues]);

    const handleTabChange = React.useCallback((_e, newValue) => {
        if (!newValue || newValue === leftPanelTab) {
            return;
        }

        setLeftPanelTab(newValue);

        if (leftPanelTab === aiTabValue && newValue !== aiTabValue) {
            setAiView(null);
        }
    }, [leftPanelTab, setLeftPanelTab, setAiView, aiTabValue]);

    return {
        handleTabChange,
    };
}


